<template>
  <div class="right_body">
    <search-box :fromData="fromData" @subSearch="subSearch"></search-box>
    <list-btn :exportUrl="exportUrl" :exportWhere="fromData" isExcelExport></list-btn>
    <tab-list
    :tabList="listArr"
    :total="total"
    :pages="pages"
    :fromData="fromData"
    :columns="tabColumns"
    tabName="report-stock-period"
    @currentChange="currentChange"
    @changePages="changePages"
    @selectSdata="selectSdata">
    </tab-list>
  </div>
</template>

<script>
import {report} from 'api/report.js';
import {excelExport} from 'api/excel.js';
import listBtn from 'components/btn/listBtn.vue';
import tabList from 'components/table/list.vue';
import searchBox from './components/period/search.vue'

export default{
  components:{
   tabList,listBtn,searchBox
  },
  data(){
    return{
      isComponentChild:false,
      sdata:{},
      listArr:[],
      exportUrl:excelExport.periodinventory,//导出url
      tabColumns:[
        {field: 'currentYear', title: '会计',width:60},
        {field: 'currentMonth', title: '会计',width:60},
        {field: 'materialCode', title: '物料编码',need:true,width:100},
        {field: 'materialDesc', title: '物料描述'},
        {field: 'factoryCode', title: '工厂',
        formatter(row, column, cellValue, index){
          let desc = row.factoryDesc ? row.factoryDesc : '';
          let code = row.factoryCode ? row.factoryCode : '';
          return code +'-'+desc;
        }},
        {field: 'inventoryDesc', title: '库存地点', 
        formatter(row, column, cellValue, index){
          let desc = row.inventoryDesc ? row.inventoryDesc : '';
          let code = row.inventoryCode ? row.inventoryCode : '';
          return code + '-'+desc;
        }},
        {field: 'availableStock', title: '可用库存',width:80},
        {field: 'inspectionStock', title: '质检库存',width:80},
        {field: 'blockedStock', title: '限制库存',width:80},
        {field: 'basicUnitDesc', title: '计量单位',width:80}
      ],//表头字段
      total:0,//总条数
      pages:0,//总页数
      fromData:{
      	page:1,//当前页
      	pageSize:20,//每页显示的数量,
      	searchCriteria:{//查询的附加条件
      	}
      }
    }
  },
  created(){
    //设置默认日期最近一个月
    const startTime = new Date().getTime() - 3600 * 1000 * 24 * 30;
    const endTime = new Date();
    this.fromData.searchCriteria.startDate = this.$moment(startTime).format("YYYY-MM-DD");
    this.fromData.searchCriteria.endDate = this.$moment(endTime).format("YYYY-MM-DD");
    this.getList();
  },
  mounted(){
    this.isComponentChild = true;
  },
  methods:{
    //选中数据
    selectSdata(data){
      this.sdata = data;
    },
    //获取列表
    async getList(){
    	let res = await this.$post(report.period,this.fromData);
    	const { data,msg,msgCode,status,type,code} = res;
      if(res.status && res.data){
        this.pages = res.data.pages;
        this.listArr = res.data.list;
        this.total = res.data.total;
      }else{
        this.pages = 0;
        this.listArr = [];
        this.total = 0;
      }
    },
    //当前页码改变
    currentChange(currentPage){
      this.fromData.page = currentPage;
      this.getList();
    },
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
    handleSelectChange(item,key){
      this.$set(this.listArr[key],'isChecked',!item.isChecked);
      if(item.isChecked){
        this.sdata = item;
        this.listArr.forEach((items)=>{
          if(items.materialId != item.materialId){
            this.$set(items,'isChecked',false);
          };
          if(item.maintainStatus === 'X'){
            this.sdata.isDel = true;
          }else{
            this.sdata.isDel = false;
          }
        });
      }else{
        this.sdata = {};
      }

    },
    //搜索
    subSearch(){
      this.fromData.page = 1;
      this.getList();
    }
  }
}
</script>

<style>
</style>
